// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ProposalScenarioFragment } from '../../../modules/proposal/graphql/ProposalScenarioFragment.generated';
import { GratTrustFragment } from '../../../modules/entities/gratTrusts/graphql/GratTrust.generated';
import { gql } from '@apollo/client';
import { ProposalScenarioFragmentDoc } from '../../../modules/proposal/graphql/ProposalScenarioFragment.generated';
import { GratTrustFragmentDoc } from '../../../modules/entities/gratTrusts/graphql/GratTrust.generated';
export type EntityProposalFragment = { __typename?: 'EntityProposal', id: string, taxDrag?: Percent | null, assetValuationProjectionType: Types.EntityProposalAssetValuationProjectionType, proposalScenarios?: Array<(
    { __typename?: 'ProposalScenario' }
    & ProposalScenarioFragment
  )> | null, entity: { __typename?: 'Entity', id: string, stage: Types.EntityStage, gratTrust?: (
      { __typename?: 'GRATTrust' }
      & GratTrustFragment
    ) | null } };

export const Operations = {
  Fragment: {
    EntityProposal: 'EntityProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityProposalFragmentDoc = gql`
    fragment EntityProposal on EntityProposal {
  id
  proposalScenarios {
    ...ProposalScenario
  }
  taxDrag
  assetValuationProjectionType
  entity {
    id
    stage
    gratTrust {
      ...GratTrust
    }
  }
}
    ${ProposalScenarioFragmentDoc}
${GratTrustFragmentDoc}`;